import React, { useRef, useEffect, useCallback, useState} from 'react';
import EffectEdges from './EffectEdges.js';
import EffectInput from './EffectInput.js';
import EffectOutput from './EffectOutput.js';
import PullableInstrument from './PullableInstrument.js';
import {useWindowManager} from "components/windows/useWindowManager.js";
import {LIVE_FX, AUDIO_FX} from 'constants/effect-types.js';
import {connect} from 'react-redux';
import EffectComponent from "components/effects/EffectComponent.js";
import MidiEffectComponent from "components/effects/MidiEffectComponent.js";
import LiveEffectComponent from "components/effects/LiveEffectComponent.js";
import '../../Pulled.scss';

const PulledEffect = ({
    fx,
    scale,
    containerRef,
    sequencerEngine,
    setSize,
    elements,
    size,
    sizeRef,
    setOrdering,
    ordering,
    rack,
    coords,
    isSelected,
    onDelete,
    showDelete,
    isCollapsed,
    pad
}) => { 
    const ref = useRef(undefined);
    const {style, onContextMenu, isDragging, onMouseDown, onMouseUp, setCoords} = useWindowManager({
        scale,
        ref,
        sequencerEngine,
        sizeRef,
        windowPosition: coords,
        containerRef,
        size,
        setSize,
        elements: elements,
        element: fx,
        expand: isCollapsed,
        setOrdering,
        ordering,
    });

    let className = "pulled-effect";
    if (isDragging) {
        className += " dragging";
    }
    if (isSelected) {
        className += " selected";
    }

    let _style = {... style};
    if (coords) {
        _style.left = coords.x;
        _style.top = coords.y;
    }
    let num = fx.numberOfOutputs || 1;
    let outputs = new Array(num).fill(0).map(
        (a,i) => i);
    let l = [
        <div
          key={1}
          style={_style}
          onContextMenu={onContextMenu}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          ref={ref} className={className}>
        {fx.instrument ?
         <PullableInstrument
           onDeleteEffect={() => onDelete(fx)}
           showStar={true}
           sequencerEngine={sequencerEngine}
           instrumentPart={fx}/> :
         fx.getEffectType() === AUDIO_FX ?
           <EffectComponent
             showDelete={showDelete}
             isDraggable={false}
             sequencerEngine={sequencerEngine}
             showStar={true}
             featured={true}
             track={fx.track}
             compact={true}
             instrument={true}
             onDeleteEffect={() => onDelete(fx)}
             effect={fx}
             send={undefined}/>
           :
           fx.getEffectType() === LIVE_FX ?
           <LiveEffectComponent
             featured={true}
             isDraggable={false}
             sequencerEngine={sequencerEngine}
             showStar={true}
             onDeleteEffect={() => onDelete(fx)}
             effect={fx}
             track={fx.track}
             onEffectsChange={() => []}/> :
           <MidiEffectComponent
             showDelete={showDelete}
             isDraggable={false}
             featured={true}
             sequencerEngine={sequencerEngine}
             track={fx.track}
             showStar={true}
             compact={true}
             instrument={true}
             onDeleteEffect={() => onDelete(fx)}
             effect={fx}
             send={undefined}/>}
          {pad && <EffectInput containerRef={containerRef} fx={fx} pad={pad}/>}
          {pad &&
           outputs.map(
               number => 
                   <EffectOutput
                     nodeRef={ref}
                     rack={rack}
                     coords={coords}
                     outputNumber={number}
                     containerRef={containerRef}
                     fx={fx}
                     pad={pad}/>)}
        </div>];
    return l;
};

const mapStateToProps = (state, props) => {
  return {
      coords: state.windows.windowPositions[props.fx.id],
      isCollapsed: state.effects.effectCollapsed[props.fx.id],
      numberOfOutputs: props.fx.numberOfOutputs,
      isSelected: state.windows.selectedElements[props.fx.id]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PulledEffect);
